import { DataLayerItem } from "~/utils/interface";

export const getFirstLetter = (str: string): string => {
  return str.charAt(0).toUpperCase();
};

export const capitalizeFirstLetter = (str: string): string => {
  return getFirstLetter(str) + str.slice(1);
};

export const secondsToDaysHoursMinutes = (seconds?: number): string => {
  if (!seconds || isNaN(seconds)) return "0d 0h 0m";
  const hours: number = Math.floor((seconds % 86400) / 3600);
  const minutes: number = Math.floor((seconds % 3600) / 60);

  return `${hours}h ${minutes}m`;
};

export const formatTimestamp = (time: number) => {
  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time % 60)
    .toString()
    .padStart(2, "0");
  return `${minutes}:${seconds}`;
};

export const sendToDataLayer = (data: DataLayerItem) => {
  if (window?.dataLayer) {
    window.dataLayer.push(data);
    console.log("Data sent to DataLayer: ", data);
  }
};
